<template>
  <div id="main" class="all_colors" data-scroll-offset="85">
    <div id="after_full_slider_1" class="main_color av_default_container_wrap container_wrap sidebar_right">
      <div class="container">
      <div style="margin-top: 10px!important;" class="av-special-heading av-special-heading-h3 meta-heading avia-builder-el-4  el_after_av_textblock  el_before_av_heading">
      <h3 class="av-special-heading-tag " itemprop="headline">Javni poziv / Public Invitation</h3>
      <div class="special-heading-border"><div class="special-heading-inner-border"></div></div>
      </div>
        <div style="margin-top: 10px!important;" class="av-special-heading av-special-heading-h4 meta-heading blockquote modern-quote avia-builder-el-5 el_after_av_heading el_before_av_contact">
          <div>
          <!-- eslint-disable vue/no-v-html -->
            <div class="avia_textblock" v-html="education.description">
            </div>
            <!-- eslint-enable -->
          </div>
          <div style="padding-bottom:10px; margin-top: 10px!important;" class="av-special-heading av-special-heading-h4 meta-heading blockquote modern-quote  avia-builder-el-5  el_after_av_heading  el_before_av_contact   ">
            <h4 class="av-special-heading-tag" itemprop="headline">Datum održavanja / Date of the event: <span>{{education.date_of_occurrence}} </span> </h4>
          </div>
          <div style="padding-bottom:10px; margin-top: 10px!important;" class="av-special-heading av-special-heading-h4 meta-heading blockquote modern-quote  avia-builder-el-5  el_after_av_heading  el_before_av_contact   ">
            <h4 class="av-special-heading-tag" itemprop="headline">Krajnji rok za prijavu / Application deadline: <span>{{education.application_deadline}}</span> </h4>
          </div>
        </div>
      </div>
      <div id="" class="container">
      <div style="padding-bottom:10px;" class="av-special-heading av-special-heading-h3 meta-heading avia-builder-el-4  el_after_av_textblock  el_before_av_heading">
      <h3 class="av-special-heading-tag " itemprop="headline">Prijava / Application</h3>
      <div class="special-heading-border"><div class="special-heading-inner-border"></div></div>
      </div>
          <form class="avia_ajax_form av-form-labels-visible avia-builder-el-6 el_after_av_heading avia-builder-el-last" data-avia-form-id="1">
            <fieldset> 
            <p id="element_avia_1_1" class="first_form form_element form_element_half">
              <label for="avia_1_1">Ime / Frist Name <abbr class="required" title="required">*</abbr></label> 
              <input id="avia_1_1" v-model="participant.first_name" name="avia_1_1" class="text_input is_empty" type="text"/>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_2_1">Prezime / Last Name <abbr class="required" title="required">*</abbr></label> 
              <input id="avia_2_1" v-model="participant.last_name" name="avia_2_1" class="text_input is_empty" type="text"/>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_3_1">Datum rođenja / Date of Birth <abbr class="required" title="required">*</abbr></label> 
              <input id="avia_3_1" v-model="participant.date_of_birth" name="avia_3_1" class="text_input is_empty avia-datepicker-div" type="date"/>
              <input v-model="participant.date_of_birth" type="hidden" name="date">
            </p>
            <p class="first_form form_element form_element_half"> 
              <label for="avia_5_1">Spol / Gender <abbr class="required" title="required">*</abbr></label> 
              <dropdown id="avia_5_1" v-model="participant.sex" name="avia_5_1" :options="sexTypes" :selected="sexTypeObject" v-on:updateOption="methodToRunOnSelectParticipantSex"></dropdown>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_6_1">Mjesto prebivališta <span>(Dozvoljena su samo slova) </span>/ Place of Residance <span>(Only letters) </span><abbr class="required" title="required">*</abbr></label> 
              <input id="avia_6_1" v-model="participant.place_of_residence" name="avia_6_1" class="text_input is_empty" type="text" placeholder="Grad" v-on:keypress="isLetter($event)"/>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_7_1">Zanimanje <span>(Dozvoljena su samo slova) </span>/ Occupation <span>(Only letters) </span><abbr class="required" title="required">*</abbr></label> 
              <input id="avia_7_1" v-model="participant.occupation" name="avia_7_1" class="text_input is_empty" type="text" v-on:keypress="isLetter($event)"/>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_8_1">Obrazovanje <span>(Dozvoljena su samo slova) </span>/ Education <span>(Only letters) </span><abbr class="required" title="required">*</abbr></label> 
              <input id="avia_8_1" v-model="participant.education_level" name="avia_8_1" class="text_input is_empty" type="text" v-on:keypress="isLetter($event)"/>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_9_1">Telefon <span>(Dozvoljeni su samo brojevi) </span>/ Phone number <span>(Only numbers) </span><abbr class="required" title="required">*</abbr></label> 
              <input id="avia_9_1" v-model="participant.phone" name="avia_9_1" class="text_input is_empty" type="tel" pattern="" placeholder="0038761123456" v-on:keypress="isNumber($event)"/>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_10_1">Email <abbr class="required" title="required">*</abbr></label> 
              <input id="avia_10_1" v-model="participant.email" name="avia_10_1" class="text_input is_empty" type="text" />
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_11_1">Link profila društvene mreže (LinkedIn/FB/IG) / Social media link (LinkedIn/FB/IG) </label> 
              <input id="avia_11_1" v-model="participant.link_for_social_media" name="avia_11_1" class="text_input is_empty" type="text" />
            </p>
            <p class="first_form form_element form_element_half">
              <label v-if="education.application_type == 'Motivaciono pismo'" for="avia_12_1">Motivaciono pismo <span>(do jedne stranice)</span> / Motivational Letter <span>(up to one page)</span> <abbr v-if="education.application_type == 'Motivaciono pismo'" class="required" title="required">*</abbr></label> 
              <textarea v-if="education.application_type == 'Motivaciono pismo'" id="avia_12_1" v-model="application.motivational_letter" name="avia_12_1" class="text_area is_empty" cols="40" rows="7" spellcheck="false" type="text" :maxlength="1800"></textarea> 
              <label v-if="education.application_type == 'Esej'" for="avia_13_1">Esej / Essay <abbr v-if="education.application_type == 'Esej'" class="required" title="required">*</abbr></label> 
              <textarea v-if="education.application_type == 'Esej'" id="avia_13_1" v-model="application.motivational_letter" name="avia_13_1" class="text_area is_empty" cols="40" rows="7" spellcheck="false" type="text"></textarea>
            </p>
            <p class="first_form form_element form_element_half">
              <label for="avia_14_1">Da li ste član političke partije? <span>(Ako da, potrebno je upisati koje/ Dozvoljena su samo slova)</span> / Are you member of political party? <span>(If yes, please write which one/ Only letters)</span></label> 
              <input id="avia_14_1" v-model="isPartOfPolParty" name="avia_14_1" type="checkbox" class="" checked="checked" @change="$emit('input', $event.target.checked)"/> DA / YES
              <abbr v-if="isPartOfPolParty" class="required" title="required">*</abbr>
              <input v-if="isPartOfPolParty" v-model="participant.member_of_political_party" class="text_input is_empty" type="text" placeholder="" v-on:keypress="isLetter($event)"/> 
            </p>
             <p class="first_form form_element form_element_half">
              <label for="avia_15_1">Da li ste član nevladine organizacije? <span>(Ako da, potrebno je upisati koje/ Dozvoljena su samo slova)</span> / Are you member of non-governmental organization? <span>(If yes, please write which one/ Only letters)</span></label> 
              <input id="avia_15_1" v-model="isPartOfNgo" class="checkbox" name="avia_15_1" type="checkbox" checked="checked" @change="$emit('input', $event.target.checked)"/> DA / YES
              <abbr v-if="isPartOfNgo" class="required" title="required">*</abbr>
              <input v-if="isPartOfNgo" v-model="participant.member_of_ngo" class="text_input is_empty" type="text" placeholder="" v-on:keypress="isLetter($event)"/> 
            </p>
              <p class="first_form form_element form_element_half">
              <label for="avia_16_1">Da li ste prisustvovali ranijim programima/edukacijama? <span>(Ako da, potrebno je upisati na kojim. Ukoliko ih je vise, iste odvojite zarezom)</span> / Have you attended previous programs/educations? <span>(If yes, please write which one. If there are many, use comma as a separator.)</span></label> 
              <input id="avia_16_1" v-model="alreadyAttended" class="checkbox" name="avia_16_1" type="checkbox" checked="checked" @change="$emit('input', $event.target.checked)"/> DA / YES
              <abbr v-if="alreadyAttended" class="required" title="required">*</abbr>
              <input v-if="alreadyAttended" v-model="participant.attended_to_prev_educations" class="text_input is_empty" type="text" placeholder="" />
             </p>
            <p class=" first_form  form_element form_fullwidth">
              <span class="disclaimer"><abbr class="required" title="required">*</abbr> Poštovani, podaci koje unosite u formu aplikacije za navedeni Javni poziv koriste se isključivo u svrhu  odabira učesnika programa te se u druge svrhe neće koristiti. Forum lijeve inicijative garantuje tajnost podataka u skladu sa Zakonom o zaštiti ličnih podataka ( "Službeni glasnik BiH", broj: 49/06). / The data you enter in the application form for the Public Invitation are used exclusively for the purpose of selecting program participants and will not be used for other purposes. The Left Initiative Forum guarantees the confidentiality of data in accordance with the Law on Personal Data Protection ("Službeni glasnik BiH", No. 49/06).</span>
            </p>
             <p class="form_element">
              <input
              class="button"
                type="button"
                name="add participant"
                value="Prijavi se / Submit"
                @click="submit(event)"
              />
            </p>
            <p v-if="errors.length">
              <b>Neispravno: / Error:</b>
              <ul>
                <li v-for="error in errors" :key="error"><abbr class="required" title="required">*</abbr> {{ error }}</li>
              </ul>
            </p>
            </fieldset>
          </form>
        </div>
      </div>
  </div>
</template>

<script>
import Dropdown from "../components/Dropdown.vue";

import {
  createParticipant,
  getParticipantByEmail,
  updateParticipant
} from "../models/ParticipantsModel";

import {
  createApplication,
  getApplicationByParticipant,
  getApplicationByParticipantForSpecificEducationType
} from "../models/ApplicationsModel";

import {
  GetEducationByID
} from "../models/EducationsModel";

export default {
  name: "Home",
  components: {
    'dropdown': Dropdown
  },
  props: {
    msg: String
  },
  data() {
    return {
      errors: [],
      isPartOfPolParty: false,
      isPartOfNgo: false,
      alreadyAttended: false,
      participant: {
        fauna_id: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // Generate unique ID for migration
        first_name: "",
        last_name: "",
        date_of_birth: "",
        sex:"",
        place_of_residence: "",
        occupation: "",
        education_level: "",
        phone: "",
        email: "",
        link_for_social_media: "",
        member_of_political_party: "",
        member_of_ngo: "",
        attended_to_prev_educations: "",
        cannot_attend: false
      },
      sexTypes: [
        {data: {
          name: "Žensko"
        }
        },
        {data:{
          name: "Muško"
          }
        },
        {data:{
          name: "Ostali"
          }
        }
      ],
      sexTypeObject: {
          name: "Izaberite spol / Choose"
      },
      allParticipants: [],
      application: {
        fauna_id: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // Generate unique ID
        participant_first_name: "",
        participant_last_name: "",
        participant_email: "",
        participant_phone: "",
        education_fauna_ref: "", // Will be set from education.fauna_id
        education_name: "",
        education_type: "",
        education_date: "",
        motivational_letter: ""
      },
      education: {
        title: "",
        description: "",
        education_type_name: "",
        application_deadline: "",
        date_of_occurrence: "",
        application_type: "",
        prevent_double_application: false
      },
      sameTypeEducations: [],
      allApplications: [],
      exists: false,
      sameEducationType: false
    };
  },
  beforeMount() {
    GetEducationByID(this.$route.params.id).then(resp => {
        this.education = resp.data;
      })
      .catch(err => console.error("problem getting education", err));
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    
    submit: function (e) {
      this.errors = [];

      const currentDate = new Date().toISOString().split('T')[0];
      if (this.education.application_deadline < currentDate) {
        this.errors.push("Rok za prijavu je istekao / The deadline for registration has expired");
      }
      if (!this.participant.first_name) {
        this.errors.push("Ime je neophodno / First name required");
      }
      if (!this.participant.last_name) {
        this.errors.push("Prezime je neophodno / Last name required");
      }
      if (!this.participant.date_of_birth || Object.keys(this.participant.date_of_birth).length === 0) {
        this.errors.push("Datum rođenja je neophodan / DoB required");
      }
      if (!this.participant.sex) {
        this.errors.push("Spol je neophodan / Gender required");
      }
      if (!this.participant.place_of_residence) {
        this.errors.push("Mjesto prebivališta je neophodno / Place of residance required");
      }
      if (!this.participant.occupation) {
        this.errors.push("Zanimanje je neophodno / Occupation required");
      }
      if (!this.participant.education_level) {
        this.errors.push("Obrazovanje je neophodno / Education required");
      }
      if (!this.participant.phone) {
        this.errors.push("Broj telefona je neophodan / Phone number required");
      }
      if (this.isPartOfPolParty!= "") {
        if (!this.participant.member_of_political_party) {
          this.errors.push("Ukoliko ste član političke stranke, neophodno je navesti i koje / Political party required");
        }
      }
      if (this.alreadyAttended!= "") {
        if (!this.participant.attended_to_prev_educations) {
          this.errors.push("Ukoliko ste prethodno sudjelovali na nekoj edukaciji, neophodno je navesti i kojoj / Previous education you have attended are required");
        }
      }
      if (this.isPartOfNgo!= "") {
        if (!this.participant.member_of_ngo) {
          this.errors.push("Ukoliko ste član NVO, neophodno je navesti i koje / NGO required");
        }
      }
      if (!this.participant.email) {
        this.errors.push('Email je neophodan / Email required');
      } else if (!this.validEmail(this.participant.email)) {
        this.errors.push('Email nije validan / Email not valid');
      }

      if (!this.errors.length) {

        this.application.participant_first_name = this.participant.first_name;
            this.application.participant_last_name = this.participant.last_name;
            this.application.participant_email = this.participant.email;
            this.application.participant_phone = this.participant.phone;
            this.application.participant_date_of_birth = this.participant.date_of_birth;
            this.application.participant_residence = this.participant.place_of_residence;
            this.application.participant_occupation = this.participant.occupation;
            this.application.participant_political_party = this.participant.member_of_political_party;
            this.application.participant_ngo = this.participant.member_of_ngo;

            this.application.education_fauna_ref = this.education.fauna_id; // Use fauna_id for foreign key
            this.application.education_name = this.education.title;
            this.application.education_date = this.education.date_of_occurrence;
            this.application.education_type = this.education.education_type_name;

        /**
        * Create new participant to db
        */
        getParticipantByEmail(this.participant.email).then(resp => {
          if(resp.data === undefined || resp.data === null){ 
            // New participant - create participant and application
            createParticipant(this.participant)
              .then(resp => {
                if(resp.error) {
                  alert("There was a problem creating participant");
                  console.error(resp.error);
                  return;
                }
                this.allParticipants.push(resp);
                createApplication(this.application)
                      .then(resp => {
                        if(resp.error) {
                          alert("There was a problem adding application");
                          console.error(resp.error);
                          return;
                        }
                        this.allApplications.push(resp);
                        alert("Prijava uspješna");
                        this.$router.push('/')
                      })
                      .catch(err => {
                        alert("There was a problem adding application");
                        console.error(err);
                      });
              })
              .catch(err => {
                alert("There was a problem creating participant");
                console.error(err);
              });
            }
            else {
              // Existing participant
              if(resp.data.cannot_attend == true) {
                alert("Prijava nije moguća. Molimo Vas da kontaktirate FLI administraciju");
                location.href = 'http://www.fli.ba/o-nama-2/kontakt/';
              }
              else {
              // Check if participant already attended similar education type
              getApplicationByParticipantForSpecificEducationType(this.participant.email, this.education.education_type_name, 0)
              .then(resp => {
                if(resp.data === undefined || resp.data.length === 0) {
                  // Check if participant already applied to this specific education
                  getApplicationByParticipant(this.participant.email, this.education.fauna_id).then(resp => {
                    if(resp.data === undefined || resp.data.length === 0){
                      // No existing application for this education - create new application
                      createApplication(this.application)
                              .then(resp => {
                                if(resp.error) {
                                  alert("There was a problem adding application");
                                  console.error(resp.error);
                                  return;
                                }
                                this.allApplications.push(resp);
                                alert("Prijava uspješna");
                                this.$router.push('/')
                              })
                              .catch(err => {
                                alert("There was a problem adding application");
                                console.error(err);
                              });
                    }
                    else {
                      alert("Već ste prijavljeni na ovu edukaciju!");
                      this.$router.push('/')
                    }
                  })
                  .catch(err => {
                    console.error("problem getting application by participant", err);
                  });
                }
                else { 
                  // Found attendance record for similar education type
                  if (this.education.prevent_double_application) {
                    alert("Prijava nije moguća. Već ste prisustvovali edukaciji ovog tipa. Ako mislite da je došlo do greške, molimo Vas da kontaktirate FLI administraciju");
                    location.href = 'http://www.fli.ba/o-nama-2/kontakt/';
                  }
                }
              })
              .catch(err => {
                console.error("problem getting applications by education type", err);
              });
                
                // Update participant data
                updateParticipant(resp.data.id, this.participant)
                .then(resp => {
                  if(resp.error) {
                    console.error("problem updating participant", resp.error);
                  }
                })
                .catch(err => {
                  console.error("problem updating participant", err);
                });
              }
            }
          })
          .catch(err => {
            alert("There was a problem getting participant");
            console.error(err);
          });
      }
      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/^[a-zA-Z\s]*$/.test(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },

    methodToRunOnSelectParticipantSex (payload) {
            this.sexTypeObject = payload;
            this.participant.sex = payload.name;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
 

  .disclaimer{
    font-size: 12px;
  }

  h4 {
    color: #474647!important;
  }
  h4 span{
    color: #919191!important;
  }

  .avia_textblock p, .avia_textblock p span {
    color: #474647;
    font-size: 14px!important;
  }
</style>
